import React from 'react';
import styled from 'styled-components';

const StyledInventoryIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const InventoryIcon: React.FC = () => (
  <StyledInventoryIcon viewBox="0 0 24 24">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14H6v-2h4v2zm4 0h-2v-4h2v4zm4 0h-2v-6h2v6zm0-8H6V5h12v4z" />
  </StyledInventoryIcon>
);

export default InventoryIcon;